<i class="icon-component label-icon notranslate" :class="iconClass" translate="no"><slot></slot></i>